module.exports = __webpack_public_path__ + "img/oe-back.png";